import { Route } from 'react-router-dom';

// Layout Principal
import { Layout } from '../components/Layout';

// Páginas Públicas
import { HomePage } from '../pages/HomePage';
import { ServicesPage } from '../pages/ServicesPage';
import { ServiceLandingPage } from '../pages/ServiceLandingPage';
import { TechnologiesPage } from '../pages/TechnologiesPage';
import { PortfolioPage } from '../pages/PortfolioPage';
import { AboutPage, PartnersPage, FaqPage } from '../pages/StaticPages';
import { ContactPage } from '../pages/ContactPage';
import { TermsPage } from '../pages/TermsPage';
import { PrivacyPage } from '../pages/PrivacyPage';

export function RoutesLayout() {
  return (
    <Route element={<Layout />}>
      {/* Página Inicial */}
      <Route path="/" element={<HomePage />} />

      {/* Institucional e Soluções */}
      <Route path="/servicos" element={<ServicesPage />} />
      <Route path="/tecnologias" element={<TechnologiesPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/sobre" element={<AboutPage />} />
      <Route path="/parceiros" element={<PartnersPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/contato" element={<ContactPage />} />

      {/* Landing Pages Técnicas de Serviços */}
      <Route path="/web" element={<ServiceLandingPage path="/web" />} />
      <Route path="/redes" element={<ServiceLandingPage path="/redes" />} />
      <Route path="/servidores" element={<ServiceLandingPage path="/servidores" />} />
      <Route path="/dns-dominios" element={<ServiceLandingPage path="/dns-dominios" />} />
      <Route path="/seguranca" element={<ServiceLandingPage path="/seguranca" />} />

      {/* Compliance e LGPD */}
      <Route path="/termos" element={<TermsPage />} />
      <Route path="/privacidade" element={<PrivacyPage />} />
    </Route>
  );
}